class WishlistStore {
  static KEY = 'wishlistIds';

  static get() {
    try {
      return JSON.parse(localStorage.getItem(this.KEY)) || [];
    } catch {
      return [];
    }
  }

  static set(ids) {
    localStorage.setItem(this.KEY, JSON.stringify(ids));
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { ids } }));
  }

  static has(id) {
    return this.get().includes(String(id));
  }

  static add(id) {
    const ids = [...new Set([...this.get(), String(id)])];
    this.set(ids);
  }

  static remove(id) {
    const ids = this.get().filter(x => x !== String(id));
    this.set(ids);
  }
}

class WishlistCheckbox extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="checkbox"]');
    this.productId = this.input.value;
    this.input.checked = WishlistStore.has(this.productId);
    this.input.addEventListener('change', this.onChange.bind(this));
  }

  onChange() {
    this.input.checked ? WishlistStore.add(this.productId) : WishlistStore.remove(this.productId);
  }
}

class WishlistHeaderIcon extends HTMLElement {
  connectedCallback() {
    this.updateCount(WishlistStore.get().length);
    document.addEventListener('wishlist:change', (e) => this.updateCount(e.detail.ids.length));
  }

  updateCount(count) {
    this.querySelectorAll('[data-wishlist-count], [data-count]').forEach(el => {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }
}
customElements.define("wishlist-checkbox", WishlistCheckbox);
customElements.define("wishlist-header-icon", WishlistHeaderIcon);